import { CommercialAddress } from "../types/proposal";

type ViaCepResponse = {
  cep?: string;
  logradouro?: string;
  complemento?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean;
};

const onlyDigits = (value: string): string => value.replace(/\D/g, "");

export const searchAddressByZipCode = async (
  zipCode: string,
): Promise<Partial<CommercialAddress>> => {
  const normalizedZipCode = onlyDigits(zipCode);
  if (normalizedZipCode.length !== 8) {
    throw new Error("Informe um CEP com 8 números.");
  }

  const response = await fetch(
    `https://viacep.com.br/ws/${normalizedZipCode}/json/`,
  );
  if (!response.ok) throw new Error("Não foi possível consultar o CEP.");

  const data = (await response.json()) as ViaCepResponse;
  if (data.erro) throw new Error("CEP não encontrado.");

  return {
    zipCode: data.cep ?? zipCode,
    street: data.logradouro ?? "",
    complement: data.complemento ?? "",
    neighborhood: data.bairro ?? "",
    city: data.localidade ?? "",
    state: data.uf ?? "",
  };
};
